import loadable from "./loadable";

export default function loadAsyncComponent({ ...options }) {
  return loadable({
    ...options,
  });
}
